<mat-card>
    <mat-card-content class="newOrder">
        <div class="newReqHead">
            <title-back [addTitle]="true" [Title]="'Off-Hire Containers '" (back)="closeDetails()"> </title-back>
        </div>
        <span></span>
        <!-- <span class="desc"> -->
        <!--     Copy paste the container numbers to mark them as 'OFF-HIRED' -->
        <!-- </span> -->
        <div fxLayout="column" class="containerOffHireBox">
            <span class="boxTitle">Container No*</span>
            <app-text-field [isMultiline]="true" [isEditable]="true"
                [(ngModel)]="containerOffhireObject.container_numbers"
                placeholder="Enter the container numbers to off-hire from the inventory. Only valid containers will be off-hired"
                [name]="'description'" class="" fxLayout="column" [maxlength]="3000">
            </app-text-field>
            <!-- <app-text-field [label]="'Off-Hire Remarks'" [isMultiline]="true" [isEditable]="true"
                [(ngModel)]="containerOffhireObject.remarks" fxLayout="column"></app-text-field> -->
        </div>

        <div class="actionBtn">
            <button mat-raised-button class="addBtn" (click)="validateContainers()">Submit</button>
        </div>
        <div class="chargeList mt-4" *ngIf="containerList?.data.length">
            <span class="tableTitle">Off-Hired Containers</span>
            <!-- <ng-container *ngIf="!containerList?.data.length">
                <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
            </ng-container> -->
            <!-- <ng-container > -->
                <div class="setTable">
                    <mat-table [dataSource]="containerList" matSort (matSortChange)="announceSortChange($event)">

                        <ng-container matColumnDef="container_number">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Container No.</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <span class="containerNumber">{{element.container.container_number ?? '-'}}</span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="size_type">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Size Type</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.container?.container_size_type}}
                            </mat-cell>
                        </ng-container>
                        <!-- <ng-container matColumnDef="droff_off">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Drop-off Location </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.pods}}
                            </mat-cell>
                        </ng-container> -->
                        <ng-container matColumnDef="mnr_status">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> MNR Status</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.mnr_status?.value}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="booking_ref">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Booking Rref. No.</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.request?.request_number}}
                            </mat-cell>
                        </ng-container>
                        <!-- <ng-container matColumnDef="system_remarks">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>System Remarks </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.pickup_depot_name ?? '-'}}
                            </mat-cell>
                        </ng-container> -->
                        <ng-container matColumnDef="off_hire_date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Off-Hire Date</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{(element.activity_date | date:'dd MMM, yyyy') ?? '-'}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="off_hire_location">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Off-Hire Location</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.current_location?.name ?? '-'}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="off_hire_remarks">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Off-Hire Remarks</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.remarks ?? '-'}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="off_hire_by">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Off-Hired By</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="fs-13">
                                {{element.updated_by?.first_name ?? '-'}} {{element.updated_by?.last_name ?? '-'}}
                            </mat-cell>
                        </ng-container>
                        <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;" [class.blur]="update"></mat-row>
                    </mat-table>
                    <div class="loadingData" [class.d-none]="!update">
                        <logzy-gear-loader></logzy-gear-loader>

                    </div>
                </div>
                <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" [length]="pageLength"
                (page)="pageChanged($event)" aria-label="Select page of Charges">
            </mat-paginator> -->
            <!-- </ng-container> -->
        </div>
    </mat-card-content>

</mat-card>